var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnabledScreenWake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1 { fill: none; } ")), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 2,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6675,
    y: 6.8536,
    width: 4.958,
    height: 1.9998,
    transform: "translate(1.5191 19.3744) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 15,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.1466,
    y: 21.6675,
    width: 1.9998,
    height: 4.958,
    transform: "translate(-10.0018 24.1465) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 25,
    width: 2,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.3745,
    y: 23.1466,
    width: 4.958,
    height: 1.9998,
    transform: "translate(-14.7739 12.6256) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15,
    width: 5,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.8536,
    y: 5.3745,
    width: 1.9998,
    height: 4.958,
    transform: "translate(-3.253 7.8535) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10a6,6,0,1,0,6,6,6,6,0,0,0-6-6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnabledScreenWake);
export default __webpack_public_path__ + "static/media/enabledScreenWake.b66dedf6e92e91a05b6aed82393a5647.svg";
export { ForwardRef as ReactComponent };